<template>
  <div style="overflow: none; height: 100vh;">
    <v-layout column fill-height>
      <v-toolbar
        flat
        :color="userSettings.useDarkMode ? 'grey darken-3' : 'grey lighten-2'"
        style="z-index: 3"
      >
        <v-toolbar-title>
          <v-icon>mdi-bookmark-multiple-outline</v-icon> Bokmerker
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="hideDrawer">
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </v-toolbar>

      <v-toolbar class="pl-0 mr-0 secondary toolbar-without-padding" dense>
        <v-toolbar-items> </v-toolbar-items>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="pl-0"
              @click="addNewBookmark"
              flat
              v-on="on"
              style="font-weight: bold;"
              small
              color="blue"
            >
              <v-icon class="pr-2 pl-0">mdi-bookmark-plus-outline</v-icon>
              Legg til bokmerke
            </v-btn>
          </template>
          <span>Legg til bokmerke for kartutsnitt</span>
        </v-tooltip>

        <v-spacer></v-spacer>
      </v-toolbar>

      <div
        class="elevation-2"
        style="margin-top: 0px; overflow-y: scroll; height: calc(100% - 113px); overflow-x: hidden"
      >
        <v-list v-if="mapBookmarks.length > 0">
          <template v-for="(bookmark, index) in mapBookmarks">
            <v-hover :key="index">
              <v-list-tile
                class="pl-0"
                slot-scope="{ hover }"
                :key="index"
                @click="goToBookmark(bookmark)"
              >
                <v-icon small class="mr-3" color="primary"
                  >mdi-bookmark-outline</v-icon
                >

                <v-list-tile-content>
                  <v-list-tile-title
                    class="caption"
                    v-html="
                      bookmark.title +
                        (bookmark.hasOwnProperty('camera')
                          ? ' <sup>3D</sup>'
                          : '')
                    "
                  ></v-list-tile-title>
                </v-list-tile-content>

                <v-spacer />

                <v-list-tile-action
                  style="min-width: 35px;"
                  v-show="hover"
                  @click.stop="openEditBookmarkTitleDialog(bookmark, index)"
                >
                  <v-btn small icon ripple>
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </v-list-tile-action>

                <v-list-tile-action
                  style="min-width: 35px;"
                  v-show="hover"
                  @click.stop="openRemoveBookmarkConfirmDialog(bookmark, index)"
                >
                  <v-btn small icon ripple>
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-hover>

            <v-divider :key="index + 'divider'" />
          </template>
        </v-list>

        <div style="height: 100%; margin-top: -50px;" v-else>
          <v-layout align-center justify-center column fill-height>
            <div>
              <h3 style="text-align: center">
                Bokmerker gjør det enklere å gå til de stedene du bruker ofte.
              </h3>
            </div>
            <v-btn @click="addNewBookmark" flat color="blue">
              Legg til bokmerke
            </v-btn>
          </v-layout>
        </div>
      </div>

      <map-bookmarks-add-dialog
        :dialog-active="addDialogActive"
        :bookmark-title="selectedBookmarkTitle"
        @cancel="cancelBookmarkAddDialog"
        @save="saveBookmark"
      />

      <confirm-dialog
        :active="confirmDeleteBookmarkDialog"
        :text="removeBookmarkConfirmDialogText"
        title="Slett bokmerke"
        confirm-text="Ja"
        reject-text="Nei"
        @dialog-confirmed="removeBookmark"
        @dialog-rejected="closeRemoveBookmarkConfirmDialog"
      />

      <confirm-dialog
        :active="confirmOpen3dBookmarkDialog"
        text="Dette bokmerket inneholder et 3D perspektiv. Ønsker du å bytte til 3D-visning eller fortsette i 2D?"
        title="Bytte til 3D-visning?"
        confirm-text="Bytt til 3D"
        reject-text="Fortsett i 2D"
        @dialog-confirmed="open3DBookmark"
        @dialog-rejected="open3DBookmarkIn2d"
      />
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MapBookmarksAddDialog from "@/pages/MapPage/Tools/Bookmarks/MapBookmarksAddDialog";
import ConfirmDialog from "@/components/ConfirmDialog";
export default {
  name: "MapBookmarks",
  data: () => {
    return {
      addDialogActive: false,
      selectedBookmarkTitle: "",
      editBookmarkIndex: null,
      isNewBookmark: false,
      confirmDeleteBookmarkDialog: false,
      bookmarkIndexToBeRemoved: null,
      confirmOpen3dBookmarkDialog: false,
      bookmark3dTemporary: null
    };
  },
  components: {
    MapBookmarksAddDialog,
    ConfirmDialog
  },
  methods: {
    ...mapActions([
      "addMapBookmark",
      "removeMapBookmark",
      "editBookmarkTitle",
      "setSnack",
      "setShowSideMenu"
    ]),
    hideDrawer() {
      this.setShowSideMenu(false);
    },
    cancelBookmarkAddDialog() {
      this.addDialogActive = false;
      this.isNewBookmark = false;
    },
    addNewBookmark() {
      this.selectedBookmarkTitle = "";
      this.isNewBookmark = true;
      this.addDialogActive = true;
    },
    openEditBookmarkTitleDialog(bookmark, index) {
      this.editBookmarkIndex = index;
      this.selectedBookmarkTitle = bookmark.title;
      this.isNewBookmark = false;
      this.addDialogActive = true;
    },
    saveBookmark(bookmarkTitle) {
      this.addDialogActive = false;

      if (this.isNewBookmark) {
        let bookmark = {
          title: bookmarkTitle,
          extent: this.extent
        };
        if (this.is3d) {
          bookmark.camera = this.$theSceneViewObject.camera.clone();
        }

        this.addMapBookmark(bookmark);
      } else {
        // overwrite existing bookmark
        let bookmarkEditInfo = {
          newTitle: bookmarkTitle,
          index: this.editBookmarkIndex
        };
        this.editBookmarkTitle(bookmarkEditInfo);
      }
    },
    openRemoveBookmarkConfirmDialog(bookmark, index) {
      this.bookmarkIndexToBeRemoved = index;
      this.selectedBookmarkTitle = bookmark.title;
      this.confirmDeleteBookmarkDialog = true;
    },
    closeRemoveBookmarkConfirmDialog() {
      this.confirmDeleteBookmarkDialog = false;
    },
    open3DBookmarkIn2d() {
      this.confirmOpen3dBookmarkDialog = false;
      this.$theMapViewObject.extent = this.bookmark3dTemporary.extent;
      this.setSnack("Åpnet bokmerke " + this.bookmark3dTemporary.title);
    },
    removeBookmark() {
      if (this.bookmarkIndexToBeRemoved !== null) {
        this.removeMapBookmark(this.bookmarkIndexToBeRemoved);
      }
      this.closeRemoveBookmarkConfirmDialog();
    },
    open3DBookmark() {
      this.$eventHub.$emit("switch-to-3d", this.bookmark3dTemporary.camera);
      this.confirmOpen3dBookmarkDialog = false;
      this.setSnack("Åpnet bokmerke " + this.bookmark3dTemporary.title);
    },
    goToBookmark(bookmark) {
      if (this.is3d) {
        this.$theSceneViewObject.extent = bookmark.extent;
        if (bookmark.hasOwnProperty("camera")) {
          this.$theSceneViewObject.camera = bookmark.camera;
        } else {
          this.$theSceneViewObject.goTo({
            target: bookmark.extent,
            tilt: 0,
            heading: 0
          });
        }
        this.setSnack("Åpnet bokmerke " + bookmark.title);
      } else {
        if (bookmark.hasOwnProperty("camera")) {
          this.bookmark3dTemporary = bookmark;
          this.confirmOpen3dBookmarkDialog = true;
        } else {
          this.$theMapViewObject.extent = bookmark.extent;
          this.setSnack("Åpnet bokmerke " + bookmark.title);
        }
      }
    }
  },
  computed: {
    ...mapState(["mapBookmarks", "extent", "is3d", "userSettings"]),
    removeBookmarkConfirmDialogText() {
      return (
        "Er du sikker på at du ønsker å slette bokmerket <strong>" +
        this.selectedBookmarkTitle +
        "</strong>? Denne handlingen kan ikke angres."
      );
    }
  }
};
</script>

<style></style>
